import { Phone, Mail, MapPin, Clock, Send } from 'lucide-react';

const Contact = () => {
  return (
    <section className="section-container" id="contact">
      <div className="text-center max-w-3xl mx-auto mb-12 animate-fade-in">
        <div className="inline-flex items-center space-x-2 mb-4">
          <div className="h-px w-8 bg-barbecue-500"></div>
          <span className="text-barbecue-500 font-medium">KONTAKT</span>
          <div className="h-px w-8 bg-barbecue-500"></div>
        </div>
        <h2 className="heading-lg mb-4">Rezervacije in informacije</h2>
        <p className="paragraph">
          Rezervirajte mizo ali nas kontaktirajte za več informacij o naši ponudbi in dogodkih.
          Z veseljem smo vam na voljo.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
        {/* Contact Information */}
        <div className="lg:col-span-2 animate-fade-in-right">
          <div className="bg-earth-50 rounded-xl p-8 h-full">
            <h3 className="heading-md mb-8">Kontaktni podatki</h3>
            <div className="space-y-6">
              <div className="flex items-start">
                <Phone className="w-5 h-5 text-barbecue-500 mt-1 mr-4" />
                <div>
                  <h4 className="font-medium mb-1">Telefon</h4>
                  <p className="text-foreground/70">+386 2 123 4567</p>
                </div>
              </div>
              <div className="flex items-start">
                <Mail className="w-5 h-5 text-barbecue-500 mt-1 mr-4" />
                <div>
                  <h4 className="font-medium mb-1">Email</h4>
                  <p className="text-foreground/70">info@zar-bar-polskava.si</p>
                </div>
              </div>
              <div className="flex items-start">
                <MapPin className="w-5 h-5 text-barbecue-500 mt-1 mr-4" />
                <div>
                  <h4 className="font-medium mb-1">Lokacija</h4>
                  <p className="text-foreground/70">Poljska cesta 12<br />2314 Zgornja Polskava<br />Slovenija</p>
                </div>
              </div>
              <div className="flex items-start">
                <Clock className="w-5 h-5 text-barbecue-500 mt-1 mr-4" />
                <div>
                  <h4 className="font-medium mb-1">Delovni čas</h4>
                  <div className="text-foreground/70">
                    <p>Ponedeljek - Petek: 11:00 - 22:00</p>
                    <p>Sobota: 10:00 - 23:00</p>
                    <p>Nedelja: 10:00 - 22:00</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Reservation Form */}
        <div className="lg:col-span-3 animate-fade-in-left">
          <div className="bg-white rounded-xl shadow-md p-8">
            <h3 className="heading-md mb-8">Rezervacija mize</h3>
            <form className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium mb-2">Ime in priimek</label>
                  <input 
                    type="text" 
                    id="name" 
                    className="contact-input" 
                    required 
                  />
                </div>
                <div>
                  <label htmlFor="phone" className="block text-sm font-medium mb-2">Telefon</label>
                  <input 
                    type="tel" 
                    id="phone" 
                    className="contact-input" 
                    required 
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="date" className="block text-sm font-medium mb-2">Datum</label>
                  <input 
                    type="date" 
                    id="date" 
                    className="contact-input" 
                    required 
                  />
                </div>
                <div>
                  <label htmlFor="time" className="block text-sm font-medium mb-2">Čas</label>
                  <input 
                    type="time" 
                    id="time" 
                    className="contact-input" 
                    required 
                  />
                </div>
              </div>
              <div>
                <label htmlFor="guests" className="block text-sm font-medium mb-2">Število oseb</label>
                <select id="guests" className="contact-input">
                  <option value="1">1 oseba</option>
                  <option value="2">2 osebi</option>
                  <option value="3">3 osebe</option>
                  <option value="4">4 osebe</option>
                  <option value="5">5 oseb</option>
                  <option value="6">6 oseb</option>
                  <option value="more">7+ oseb</option>
                </select>
              </div>
              <div>
                <label htmlFor="message" className="block text-sm font-medium mb-2">Posebne želje ali opombe</label>
                <textarea 
                  id="message" 
                  rows={4} 
                  className="contact-input" 
                ></textarea>
              </div>
              <button type="submit" className="btn-primary w-full">
                <Send className="w-4 h-4 mr-2" />
                Pošlji rezervacijo
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Map */}
      <div className="mt-12 h-96 rounded-xl overflow-hidden shadow-md animate-fade-in">
        <iframe 
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11067.882550823026!2d15.585279695347363!3d46.41674349278893!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x476f7fc72e024fb9%3A0x7887a9c96cba2db6!2s2314%20Zgornja%20Polskava!5e0!3m2!1sen!2ssi!4v1686512345678!5m2!1sen!2ssi" 
          width="100%" 
          height="100%" 
          style={{ border: 0 }} 
          allowFullScreen 
          loading="lazy" 
          referrerPolicy="no-referrer-when-downgrade"
          title="Lokacija Žar & Bar Polskava"
        ></iframe>
      </div>
    </section>
  );
};

export default Contact;